import { RouteObject } from 'react-router'

import { dataAdminRoutes } from '@/router/DDEPaths/dataAdmin.routes'
import { distributionListRoutes } from '@/router/DDEPaths/distributionList.routes'
import { golfPricingRoutes } from '@/router/DDEPaths/golfPricing.routes'
import { licensesRoutes } from '@/router/DDEPaths/licenses.routes'
import { operatorsRoutes } from '@/router/DDEPaths/operators.dde.routes'
import { userAdminRoutes } from '@/router/DDEPaths/userAdmin.routes'

export const ddePaths: RouteObject[] = [
  ...operatorsRoutes,
  ...licensesRoutes,
  ...userAdminRoutes,
  ...dataAdminRoutes,
  ...golfPricingRoutes,
  ...distributionListRoutes
]
